import { render } from "./ModalSuporteTrocaMunicipio.vue?vue&type=template&id=7344d7b1&scoped=true"
import script from "./ModalSuporteTrocaMunicipio.vue?vue&type=script&lang=js"
export * from "./ModalSuporteTrocaMunicipio.vue?vue&type=script&lang=js"

import "./ModalSuporteTrocaMunicipio.vue?vue&type=style&index=0&id=7344d7b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7344d7b1"]])

export default __exports__